import { render } from "./Footer.vue?vue&type=template&id=5f0bca3b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5f0bca3b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f0bca3b"

export default script